<template>
<div class="info">
    <!-- <div class="info-head">
        <p class="about minor">About</p>
    </div> -->
    <div class="info-text">
        <div class="headline">
            <h1>
            A social network that celebrates debate and critical thinking
            <!-- A debate network built to celebrate critical thinking -->
            </h1>
        </div>
        <p class="desc">
            <span class="minor" v-if="truncateDesc">{{ desc|truncate(223) }}
                <span class="button-text read-more" v-show="desc.length > 223" @click="truncateDesc = false">Read More</span>
            </span>
            <span class="minor" v-else>
                <!-- {{ desc }} -->
Formation is set on a mission to visualize and elevate our public discourse.
<br><br>
Bad algorithms, filter-bubbles and personalization have brought about an age of misinformation and polarization. In which we argue too little and oppose too much.
<br><br>
Only by welcoming challenge and surrounding ourselves with people who think different and are different can we grow – individually and collectively. That's the reason to why we've created Formation – a symposium built to:
<br>– Escape our echo-chambers.
<br>– Explore conflicting perspectives.
<br>– Uncover our fallacies.
<br><br>
We want Formation to form an information network that houses this conflict, where all perspectives are to be heard, where all ideas are allowed, were we are open to express, think and progress.
<br>
<br>Debate is the medium.
<br>Debate is the guide.
<br>– Now join the debate!
<br><br>
                <span class="button-text read-more" @click="truncateDesc = true">Read Less</span>
            </span>
        </p>
    </div>

    <!-- <div class="read-more-top" v-show="desc.length > 240">
        <p class="minor button-text" v-if="truncateDesc" @click="truncateDesc = false">Read More</p>
        <p class="minor button-text" v-if="!truncateDesc" @click="truncateDesc = true">Read Less</p>
    </div> -->

</div>
</template>

<script>
export default {
  name: 'Info',
  data () {
      return {
          truncateDesc: true,
      }
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
      }
      return value
    }
  },
  computed: {
      desc () {
          return `
Formation is set on a mission to visualize and elevate our public discourse.

Bad algorithms, filter-bubbles and personalization have brought about an age of misinformation and polarization. In which we argue too little and oppose too much. 

Only by welcoming challenge and surrounding ourselves with people who think different and are different can we grow – individually and collectively. That's the reason to why we've created Formation – a symposium built to:
– Escape our echo-chambers.
– Explore conflicting perspectives.
– Uncover our fallacies.

We want Formation to form an information network that houses this conflict, where all perspectives are to be heard, where all ideas are allowed, were we are open to express, think and progress.

Debate is the medium.
Debate is the guide.
– Now join the debate!
`
      }
  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.info {
    // margin: 0 $grid-padding;
    margin: $big-margin $grid-padding $grid-padding $grid-padding;
    .info-head {
        display: flex;
        border-bottom: $line-thin solid $line-color-light;
        margin-bottom: $main-margin;
        .about {
            width: $col6;
            margin-right: $main-margin;
        }
    }
    .info-text {
        display: flex;
        .headline {
            min-width: $col6;
            max-width: $col6;
            margin-right: $main-margin;
            margin-top: 0;
            h1 {
                max-width: 700px;
                margin: 0;
                font-size: $big-h1;
            }
        }
        .desc {
            margin-top: 6px;
            margin-bottom: 18px;
            hyphens: auto;
            .read-more {
                float: right;
                font-size: $p2;
                margin-top: 5px;
            }
        }
    }
    // .read-more-top {
    //     display: flex;
    //     justify-content: flex-end;
    //     p {
    //         margin: 0;
    //     }
    // }

}

// MOBILE
@media #{$mobile} {    
    .info {
        margin: $big-margin $main-margin-mobile $main-margin-mobile $main-margin-mobile;
        .info-text {
            flex-direction: column;
            .headline, .desc {
                min-width: 100%;
            }
            .headline {
                h1 {
                    font-size: $big-h1-mobile;
                    line-height: $big-h1-mobile-line-h;
                }
            }
            .desc {
                font-size: $p2;
                margin-top: $main-margin-mobile;
                margin-bottom: calc(#{$main-margin-mobile} * 2);
                .read-more {
                    margin-top: 0;
                }
            }
        }
        .info-head { 
            margin-bottom: $main-margin-mobile;
            .update {
                display: none;
            }
        }
    }
}

</style>
